<section class="sfe-safe sfe-welcome">
  <div *ngIf="userData as user">
    <h1 class="sfe-welcome-head">
      Welcome,
      {{ user?.displayName?.replace("Admin", "Super Admin") || "Super Admin" }}
    </h1>
    <p>
      You can manage admin accounts. With great power comes great res
    </p>
    <div>
      <button
      *ngIf="authService.isSuperAdmin"
      class="sfe-capitalize sfe-button-round sfe-button-blue"
      mat-raised-button
      routerLink="/super-admin/dashboard"
    >
      Admin List
    </button>
    </div>
  </div>
</section>

<table mat-table [dataSource]="dataSource">
  <!-- Position Column -->
  <ng-container [matColumnDef]="displayedColumns[0]">
    <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[0] }}</th>
    <td mat-cell *matCellDef="let element">{{ element?.email }}</td>
  </ng-container>

  <!-- Name Column -->
  <ng-container [matColumnDef]="displayedColumns[1]">
    <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[1] }}</th>
    <td mat-cell *matCellDef="let element">
      {{ element?.companyName || "N/A" }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="displayedColumns[2]">
    <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[2] }}</th>
    <td mat-cell *matCellDef="let element">
      {{ element?.typeOfUser || "N/A" }}
    </td>
  </ng-container>

  <ng-container [matColumnDef]="displayedColumns[3]">
    <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[3] }}</th>
    <td mat-cell *matCellDef="let element">
      <p
        class="hasAdminCode"
        [title]="
          (element?.adminCode?.value || element?.adminCode) &&
          !element?.adminCode?.disabled
            ? 'the company have an admin code'
            : 'the company doesn\'t have an admin code'
        "
      >
        <mat-icon
          [color]="
            (element?.adminCode || element?.adminCode?.value) &&
            !element?.adminCode?.disabled
              ? 'primary'
              : 'warn'
          "
          >{{
            (element?.adminCode?.value || element?.adminCode) &&
            !element?.adminCode?.disabled
              ? "vpn_key"
              : element?.adminCode?.disabled
              ? "key_off"
              : "cancel"
          }}</mat-icon
        >
      </p>
    </td>
  </ng-container>

  <ng-container [matColumnDef]="displayedColumns[4]">
    <th mat-header-cell *matHeaderCellDef>{{ displayedColumns[4] }}</th>
    <td mat-cell *matCellDef="let element">
      <button
        [disabled]="!element?.adminCode && !element?.adminCode?.value"
        class="sfe-capitalize sfe-button-round sfe-button-blue more-btn"
        mat-raised-button
        (click)="
          (element?.adminCode || element?.adminCode?.value) &&
            routeToDetail(
              element?.uid,
              element?.adminCode?.value || element?.adminCode
            )
        "
      >
        {{ !element?.adminCode?.disabled ? "More" : "Code revoked" }}
      </button>
    </td>
  </ng-container>

  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
  <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
</table>
<mat-paginator
  [pageSizeOptions]="[5, 10, 20]"
  showFirstLastButtons
  aria-label="Select page of admin users"
>
</mat-paginator>
